import { useSelector } from "react-redux";

// Central permission hook.
// can(module, action) -> boolean. Super admins (legacy login) can do everything.
export function usePermissions() {
  const user = useSelector((s) => s.main?.user);
  const permissions = useSelector((s) => s.main?.permissions);

  const isSuperAdmin = !!user?.isSuperAdmin || permissions === "all";

  const can = (module, action = "view") => {
    if (isSuperAdmin) return true;
    const m = permissions?.[module];
    return !!m?.[action];
  };

  return { user, permissions, isSuperAdmin, can };
}
